import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const FAQS = [
  {
    category: 'Rezervasyon & Ödeme',
    icon: 'ri-calendar-check-line',
    items: [
      {
        q: 'Tur rezervasyonu nasıl yapabilirim?',
        a: 'Web sitemiz üzerinden istediğiniz tura tıklayıp "Rezervasyon Yap" butonuyla online rezervasyon yapabilirsiniz. Ayrıca +90 540 001 5806 numaralı telefonumuzu arayarak veya info@ankaratravelers.com adresine e-posta göndererek de rezervasyon oluşturabilirsiniz.',
      },
      {
        q: 'Hangi ödeme yöntemlerini kabul ediyorsunuz?',
        a: 'Nakit, kredi kartı (Visa, Mastercard, American Express) ve banka havalesi kabul ediyoruz. 1000 TL ve üzeri ödemelerde 12 aya varan taksit imkanı sunmaktayız.',
      },
      {
        q: 'Tur ücreti ne zaman ödenmesi gerekiyor?',
        a: 'Rezervasyon sırasında toplam ücretin %30\'u depozito olarak alınmaktadır. Kalan tutar, tur başlangıcından en az 3 iş günü önce ödenmesi gerekmektedir.',
      },
      {
        q: 'Grup indirimi var mı?',
        a: '10 kişi ve üzeri gruplarda %10, 20 kişi ve üzeri gruplarda %15 indirim uygulanmaktadır. Özel grup turları için bizimle iletişime geçebilirsiniz.',
      },
    ],
  },
  {
    category: 'İptal & İade',
    icon: 'ri-refund-2-line',
    items: [
      {
        q: 'Rezervasyonumu iptal etmek istiyorum. Nasıl işlem yapabilirim?',
        a: 'Tur tarihinden 7 gün önce yapılan iptallerde ücretin tamamı iade edilir. 3-7 gün arası iptallerde %50 iade yapılır. 3 günden az süre kala yapılan iptallerde iade yapılmamaktadır.',
      },
      {
        q: 'Tur iptal edilirse ne olur?',
        a: 'Ankara Travelers tarafından iptal edilen turlarda ücretin tamamı 3 iş günü içinde iade edilir. Ayrıca size ücretsiz yeniden rezervasyon fırsatı sunulur.',
      },
      {
        q: 'Tur tarihini değiştirebilir miyim?',
        a: 'Tur başlangıcından en az 5 iş günü önce bildirim yapıldığında, uygunluk durumuna göre tur tarihi ücretsiz değiştirilebilir. Bu süre geçtikten sonra değişiklik için 150 TL işlem ücreti alınır.',
      },
    ],
  },
  {
    category: 'Tur Detayları',
    icon: 'ri-map-pin-line',
    items: [
      {
        q: 'Turlarda ulaşım nasıl sağlanıyor?',
        a: 'Tüm turlarımızda konforlu, klimali ve GPS takipli araçlar kullanılmaktadır. Araçlarımız her yıl bakımdan geçirilmekte olup tüm güvenlik standartlarını karşılamaktadır.',
      },
      {
        q: 'Turlarda rehber var mı?',
        a: 'Tüm turlarımızda profesyonel, sertifikalı ve deneyimli rehberlerimiz eşlik etmektedir. Yurt dışı turlarında Türkçe rehber garantisi sunuyoruz.',
      },
      {
        q: 'Tura katılmak için yaş sınırı var mı?',
        a: '18 yaş altı katılımcılar veli/vasi onayıyla tura katılabilir. 12 yaş altı çocuklar için bazı turlarımızda indirimli fiyat uygulanmaktadır. Detaylar için tur sayfasını inceleyebilirsiniz.',
      },
      {
        q: 'Tur kapsamında sigorta var mı?',
        a: 'Tüm turlarımız zorunlu seyahat sigortası kapsamındadır. Ek seyahat sigortası için acentemizle iletişime geçebilirsiniz.',
      },
    ],
  },
  {
    category: 'Yurt Dışı Turlar',
    icon: 'ri-flight-takeoff-line',
    items: [
      {
        q: 'Yurt dışı turlar için hangi belgeler gerekli?',
        a: 'Avrupa turları için pasaport ve Schengen vizesi gereklidir. Vize konusunda danışmanlık hizmeti sunmaktayız ancak vize onayı ilgili büyükelçiliğe aittir. Bazı destinasyonlar için sadece geçerli pasaport yeterlidir.',
      },
      {
        q: 'Yurt dışı tur fiyatlarına neler dahil?',
        a: 'Uçak bileti, konaklama, transferler ve belirtilen yemekler dahildir. Vize ücreti, seyahat sigortası ve kişisel harcamalar ayrıca ödenmektedir.',
      },
    ],
  },
];

export default function SSSSayfasi() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  const [openIdx, setOpenIdx] = useState<string | null>(null);

  const schemaOrg = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': `${siteUrl}/sikca-sorulan-sorular`,
    url: `${siteUrl}/sikca-sorulan-sorular`,
    name: 'Sıkça Sorulan Sorular | Ankara Travelers',
    inLanguage: 'tr-TR',
    mainEntity: FAQS.flatMap(cat =>
      cat.items.map(item => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.a,
        },
      }))
    ),
  };

  const toggle = (key: string) => {
    setOpenIdx(prev => (prev === key ? null : key));
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <title>Sıkça Sorulan Sorular | Ankara Travelers Tur Acentası</title>
      <meta name="description" content="Ankara Travelers hakkında sıkça sorulan sorular: rezervasyon, ödeme, iptal koşulları, tur detayları ve yurt dışı tur bilgileri. Tüm sorularınızın cevabı burada." />
      <meta name="keywords" content="Ankara Travelers SSS, tur rezervasyon, tur iptali, Ankara çıkışlı tur soruları" />
      <link rel="canonical" href={`${siteUrl}/sikca-sorulan-sorular`} />
      <meta property="og:title" content="Sıkça Sorulan Sorular | Ankara Travelers" />
      <meta property="og:description" content="Rezervasyon, ödeme, iptal ve tur detayları hakkında en sık sorulan sorular." />
      <meta property="og:url" content={`${siteUrl}/sikca-sorulan-sorular`} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrg) }}
      />
      <Navbar />

      {/* Hero */}
      <section className="pt-20 bg-gradient-to-br from-orange-500 via-orange-400 to-amber-400">
        <div className="max-w-3xl mx-auto px-6 py-20 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl mx-auto mb-6">
            <i className="ri-question-answer-line text-3xl text-white" />
          </div>
          <h1 className="text-4xl font-bold text-white mb-4">Sıkça Sorulan Sorular</h1>
          <p className="text-orange-100 text-lg">Merak ettiğiniz her şey için buradayız. Cevap bulamadıysanız bize ulaşın.</p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6 space-y-10">
          {FAQS.map(cat => (
            <div key={cat.category}>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-100 dark:bg-orange-900/30 rounded-xl">
                  <i className={`${cat.icon} text-orange-500 text-lg`} />
                </div>
                <h2 className="text-lg font-bold text-gray-900 dark:text-white">{cat.category}</h2>
              </div>
              <div className="space-y-3">
                {cat.items.map((item, idx) => {
                  const key = `${cat.category}-${idx}`;
                  const isOpen = openIdx === key;
                  return (
                    <div
                      key={key}
                      className={`border rounded-xl overflow-hidden transition-colors ${
                        isOpen
                          ? 'border-orange-300 dark:border-orange-600 bg-orange-50 dark:bg-orange-900/10'
                          : 'border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800'
                      }`}
                    >
                      <button
                        className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                        onClick={() => toggle(key)}
                      >
                        <span className={`text-sm font-medium ${isOpen ? 'text-orange-600 dark:text-orange-400' : 'text-gray-800 dark:text-gray-200'}`}>
                          {item.q}
                        </span>
                        <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 ml-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}>
                          <i className="ri-arrow-down-s-line text-gray-400 text-xl" />
                        </div>
                      </button>
                      {isOpen && (
                        <div className="px-5 pb-5">
                          <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">{item.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 bg-gray-50 dark:bg-gray-800 transition-colors duration-300">
        <div className="max-w-xl mx-auto px-6 text-center">
          <div className="w-14 h-14 flex items-center justify-center bg-orange-100 dark:bg-orange-900/30 rounded-2xl mx-auto mb-5">
            <i className="ri-customer-service-2-line text-2xl text-orange-500" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Hâlâ sorunuz mu var?</h3>
          <p className="text-gray-500 dark:text-gray-400 text-sm mb-6">
            Uzman ekibimiz size yardımcı olmaktan memnuniyet duyacaktır.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="tel:+905400015806"
              className="flex items-center justify-center gap-2 px-6 py-3 bg-orange-500 text-white rounded-full text-sm font-medium hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line" />
              </div>
              +90 540 001 5806
            </a>
            <a
              href="mailto:info@ankaratravelers.com"
              className="flex items-center justify-center gap-2 px-6 py-3 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-full text-sm font-medium hover:border-orange-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line" />
              </div>
              E-posta Gönder
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
